import styles from "./PromoText.module.css";

const PromoText = () => {
  return (
    <section className={styles["promo-text"]}>
      <h2>Онлайн Ресторан в Київі</h2>
      <p>
      Ласкаво просимо в "Смакуй" – місцевий ресторан, де аромат і смак рідного краю об'єднуються в неповторний гастрономічний танець. У нас кожен гість – це важлива постать, а кожна страва – це історія, розповідь про традиції та унікальний характер наших місцевих продуктів.
      </p>
      <p>
      "Смакуй" - це не лише ресторан, а справжнє приголомшливе враження, де вишуканість та простота поєднуються в єдиний симфонічний досвід. Наші шеф-кухарі завжди готові здивувати вас творчим підходом до готування, надаючи кожній страві неповторний смаковий акцент. Приєднуйтеся до нас у "Смакуй" і дозвольте своїм смаковим рецепторам відкрити нові горизонти задоволення.
      </p>
    </section>
  );
};

export default PromoText;
